const TEAMS_PATH = "teams";
const TEAMS_EXT = "webp";

export const finnhouseLogoUrl = (): string =>
  `${import.meta.env.VITE_S3_ASSET_URL}/icons/finnhouse.png`;

export const teamLogoUrl = (teamId: string): string =>
  `${import.meta.env.VITE_S3_ASSET_URL}/${TEAMS_PATH}/${teamId}.${TEAMS_EXT}`;

export const onTeamLogoError = (event: React.SyntheticEvent<HTMLImageElement>): void => {
  const fallback = finnhouseLogoUrl();
  if (event.currentTarget.src !== fallback) {
    event.currentTarget.src = fallback;
  }
};
